'use strict';

import {
    BufferGeometry, Float32BufferAttribute,
    MathUtils,
    Points,
    PointsMaterial,
    TextureLoader,
    Vector3,
} from 'three';
import { Buildings, settingsData, threeJsVariables } from '../../../settings';
import { apartmentLabelHandler } from '../flatLabels/flatLabels';
import { ViewMode } from '../../../common';
import { getUrlParam } from '../../../functions';

const worldPosition = new Vector3();
// const cameraVector = new Vector3();
// const cameraPolarVector = new Vector3();
const cameraAzimuthVector = new Vector3();
// const polarVector = new Vector3();
const azimuthVector = new Vector3();
// const box = new Box3();
// const size = new Vector3();

export class Favorite {

    static favorites = [];
    static angel = config.features.favorite?.angel || 45;
    static active = config.features.favorite?.active || false;

    constructor (apt,action) {
        if (apt.getObjectByName('favorite') && action === 'add' || !Favorite.active || getUrlParam('card'))
            return;

        switch (action) {
            case 'add':
                this.add(apt);
                break;
            case 'remove':
                this.remove(apt);
                break;
        }
    }

    remove(apt) {
        const scope = Favorite.favorites.find(fav => fav.engineId === apt.userData.crm_data.engineId)?.scope;

        if (scope) {
            scope.label.removeFromParent();
            delete scope.apt.userData.favorite;
            Favorite.favorites = Favorite.favorites.filter(fav => fav.engineId !== apt.userData.crm_data.engineId);

            //Remove flatLabel
            const label = document.querySelector(`.flat-label-container[data-apartment-name="${apt.name}"]`);
            if (label) {
                label.querySelector('.in-favorite')?.classList.remove('in-favorite');
            }
        }
    }

    add (apt) {
        this.apt = apt;
        this.apt.userData.favorite = true;
        this.label = Favorite.heart.clone();
        this.label.name = 'favorite';
        this.apt.add(this.label);
        const obj = {
            engineId: this.apt.userData.crm_data.engineId,
            buildingEngineId: this.apt.userData.crm_data.buildingEngineId,
            lbl: this.label,
            scope: this
        };

        Favorite.favorites.push(obj);
        Favorite.intersect();

        // Change flat label in floorPlan mode
        const label = document.querySelector(`.flat-label-container[data-apartment-name="${apt.name}"]`);
        if (label) {
            label.querySelector('.flat-label--point')?.classList.add('in-favorite');
        }
    }

    static toggle(action) {
        if (!Favorite.active)
            return;

        const activeBuildingName = Buildings.getActiveBuilding().name;

        Favorite.favorites.forEach(label => {
            if (label.buildingEngineId === activeBuildingName) {
                label.lbl.visible = action === 'show';
            } else {
                label.lbl.visible = false;
            }
        });
    }

    static intersect() {
        if (!Favorite.active || settingsData.activeModeSwitching) return;

        if (settingsData.activeViewMode !== ViewMode.Cylinder) {
            Favorite.toggle('hide');
            return;
        }

        const activeBuildingName = Buildings.getActiveBuilding().name;

        Favorite.favorites.forEach(label => {
            if (label.buildingEngineId === activeBuildingName) {
                label.lbl.getWorldPosition(worldPosition);
                azimuthVector.copy(worldPosition);
                azimuthVector.setY(0);

                cameraAzimuthVector.copy(threeJsVariables.perspectiveCamera.position);
                cameraAzimuthVector.setY(0);

                const azimuthAngle = cameraAzimuthVector.angleTo(azimuthVector);
                const deg = MathUtils.radToDeg(azimuthAngle);

                label.lbl.visible = deg < Favorite.angel;
            } else {
                label.lbl.visible = false;
            }
        });
    }

    static load() {
        if (!Favorite.active)
            return;

        const textureLoader = new TextureLoader();
        const heart = textureLoader.load('./img/heart.png');

        const geometry = new BufferGeometry();
        geometry.setAttribute( 'position', new Float32BufferAttribute( [0,0,0], 3 ) );

        const material = new PointsMaterial({
            map: heart,
            transparent: true,
            size: 3,
            sizeAttenuation: true,
            depthTest: false
        });

        Favorite.heart = new Points(geometry,material);
    }
}
